var links = [{ title: 'Home', to: '/', icon: 'fa-home' }, { title: 'Resume', to: '/resume', icon: 'fa-file-alt' }, { title: 'History', to: '/work', icon: 'fa-briefcase' }, { title: 'Blog', to: '/blog', icon: 'fa-newspaper' }, { title: 'Contact', to: '/contact', icon: 'fa-envelope' }];
export default links;
